import gql from 'graphql-tag';
import { ChildDataProps } from 'react-apollo';
import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { get } from 'lodash';
import {
  Props as ICheckoutPaymentSelectionContinueButtonProps,
} from './checkout_payment_selection_continue_button';

import {
  SelectableCreditCardListQuery,
} from '../schemas/rql';

/* eslint-disable */
export const QUERY = gql`
query SelectableCreditCardListQuery {
  me {
    uuid
    creditCards {
      id
      last4
      cardType
      expirationYear
      expirationMonth
      cardholderName
      needsReverification
      primaryForCheckout
      # this client side field is defined locally and not
      # in the intropsection schema, which is why we're
      # turning the linting off
      isSelected @client
    }
  }
}`;
/* eslint-enable */

export type ChildProps = ChildDataProps<{}, SelectableCreditCardListQuery.Query, SelectableCreditCardListQuery.Variables>;
export const connectCheckoutButtonQuery = withGraphql<ICheckoutPaymentSelectionContinueButtonProps, SelectableCreditCardListQuery.Query, SelectableCreditCardListQuery.Variables, ChildProps>(
  QUERY,
  {
    skip: ownProps => !!get(ownProps.user, 'loggedOut', true),
    options: {
      // The parent component is rendered by a Rails/HAML view, is not routed, and does not use SSR:
      // https://github.com/reverbdotcom/reverb/blob/master/app/views/bundled_checkout/direct_checkout/_adyen_credit_card_form.haml
      ssr: false,
    },
  },
);
export const connectSelectableCreditCardListQuery = withGraphql<{}, SelectableCreditCardListQuery.Query, SelectableCreditCardListQuery.Variables>(
  QUERY,
  {
    options: {
      // The parent component is rendered by a Rails/HAML view, is not routed, and does not use SSR:
      // https://github.com/reverbdotcom/reverb/blob/master/app/views/bundled_checkout/direct_checkout/_credit_card_selection.haml
      ssr: false,
    },
  },
);

export function selectCard(_, { id }, { client }) {
  const updated = updateQueryDataInline(client.readQuery({ query: QUERY }), id);
  client.writeQuery({ query: QUERY, data: updated });
  return null;
}

export function updateQueryDataInline(originalQueryData, id) {
  const updated = { ...originalQueryData };
  updated.me.creditCards = originalQueryData.me.creditCards.map((cc) => {
    if (cc.id === id) {
      return { ...cc, isSelected: true };
    }
    return { ...cc, isSelected: false };
  });
  return updated;
}

export const resolvers = {
  core_apimessages_CreditCard: {
    isSelected: (cc) => {
      return cc.primaryForCheckout;
    },
  },
};
